module.exports = __webpack_public_path__ + "img/07.d741f8ad.jpg";